import React, { Component } from "react";

export class InputField extends Component {
    render() {
        let { inputValue, labelValue, disabled } = this.props;
        return (
            this.props.noLabel ?
            
            <span className="text_input_group">                
                <input
                    className={"input_box "+this.props.className}
                    type="text"
                    maxLength="80"
                    disabled={disabled}
                    value={inputValue}
                    id={this.props.id}
                />
            </span>
            :
            <span className="text_input_group">
                <label className="input_label" id={this.props.id}>
                    {labelValue}
                </label>
                <input
                    className="input_box"
                    type="text"
                    maxLength="80"
                    disabled={disabled}
                    value={inputValue}
                    id={this.props.id}
                />
            </span>
            
        );
    }
}


// WEBPACK FOOTER //
// ./src/features/common/InputField.js